<div
  class="phone-number-footer">
  <div
    *ngIf="header"
    class="phone-number-header"
    translate>{{header}}
  </div>
  <div
    class="phone-number-body"
    translate>{{body}}
  </div>
</div>
